import styled from 'styled-components';

import { Button } from '@xsolla/ui-core';

import { project_colors } from '../../../constants';

export const Select = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.stroke};
  font-size: 15px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.text};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  position: relative;
  width: 100%;
  padding: 6px 32px 6px 12px;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: inset 0 0 0 1px transparent;
  min-height: 44px;

  :hover {
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.colors.brand};
  }

  :hover > div:last-child {
    color: ${(props) => props.theme.colors.brand};
  }
`;

export const DropdownIconWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 10px;
`;

export const Pill = styled.div`
  border: 1px solid ${(props) => props.theme.colors.stroke};
  box-shadow: 0 2px 4px #f5f9ff;
  border-radius: 4px;
  padding: 4px 12px 4px 8px;
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.text};
`;

export const PillDeleteButton = styled(Button)`
  width: 16px;
  height: 16px;
  color: ${project_colors.NEUTRAL_LIGHT};

  :hover {
    color: ${(props) => props.theme.colors.muted};
  }
`;
